export const AUTH_ACTION = 'AUTHORIZE_RACE_REGISTRATION';
